import { BillingSettingsTranslation } from 'locales/de/pages/Billing/settings';

const en: BillingSettingsTranslation = {
  title: 'Billing data',
  tabs: {
    tax: 'Tax',
    metadata: 'Invoice data',
    revenuetype: 'Revenue Type',
    department: 'Departments / Faculties',
    article: 'Article master data'
  },
  mutation: {
    taxCreationSuccess: 'New tax was successfully created.',
    taxCreationFailed: 'An error occurred when creating the tax.',
    taxUpdateSuccess: 'The tax was successfully updated.',
    taxUpdateFailed: 'An error occurred when updating the tax.',
    metadataCreationSuccess: 'New invoice data was successfully created.',
    metadataCreationFailed: 'An error occurred when creating the invoice data.',
    metadataUpdateSuccess: 'The invoice data was successfully updated.',
    metadataUpdateFailed: 'An error occured while updating the invoice data.',
    revenueTypeCreationSuccess: 'New revenue type was successfully created.',
    revenueTypeCreationFailed: 'An error occurred while creating the revenue type.',
    revenueTypeUpdateSuccess: 'The revenue type was successfully updated.',
    revenueTypeUpdateFailed: 'An error occurred while updating the revenue type.',
    articleUpdateSuccess: 'The article was successfully updated.',
    articleUpdateFailed: 'An error occurred while updating the article.',
    departmentCreationSuccess: 'New department was successfully created.',
    departmentCreationFailed: 'An error occurred while creating the department.',
    departmentUpdateSuccess: 'The department was successfully updated.',
    departmentUpdateFailed: 'An error occurred while updating the department.'
  },
  tax: {
    key: 'Key',
    text: 'Text',
    taxRate: 'Tax rate',
    drawer: { create: 'Create new tax', update: 'Update the tax' }
  },
  revenueType: {
    revenueTypeNumber: 'Revenue type number',
    drawer: { create: 'Create new revenue type', update: 'Update the revenue type' }
  },
  metadata: {
    key: 'Key',
    text: 'Text',
    drawer: { update: 'Update the invoice data' }
  },
  article: {
    sku: 'Article number',
    drawer: { update: 'Update article' }
  },
  validation: {
    revenueType: 'The revenue type must be a number.'
  },
  department: {
    name: 'Department name',
    toggleText: 'Show disabled departments',
    drawer: {
      create: 'Create new department / faculty',
      update: 'Update the department / faculty',
      info: 'Departments and faculties can be created here, which can be selected when creating an invoice.',
      editHint:
        'Changing the department name may restrict the search for invoices that have already been created. When renaming, we recommend creating a new department and setting the old one to ‘deactivated’.'
    }
  }
};

export default en;
